// extracted by mini-css-extract-plugin
module.exports = {"tileWrapper":"NotificationTile_tileWrapper__1OrGh","highlighted":"NotificationTile_highlighted__1CYjm"};